export default __webpack_public_path__ + "static/media/dashboard-img.2d8d0f8c.png";